import type { FieldValidator } from '@lucidtech/las-sdk-browser';
import { memo } from 'react';

import { merge } from '@/components';
import { Button, ButtonProps, Text } from '@/components/core';
import { ValidatorLogo } from '@/components/logos';
import { OmitChildren } from '@/utils';

export type ValidatorCellProps = OmitChildren<ButtonProps> & {
  validator: FieldValidator;
};

const IValidatorCell = ({ validator, className, ...rest }: ValidatorCellProps) => {
  return (
    <Button
      variant="plain"
      className={merge(
        'p-xs flex w-full items-center justify-start gap-2 rounded-lg border border-gray-300 bg-gray-50',
        className
      )}
      {...rest}
    >
      <ValidatorLogo validator={validator} size="md" />
      <Text>{validator.name}</Text>
    </Button>
  );
};

export const ValidatorCell = memo(IValidatorCell) as typeof IValidatorCell;
